module.exports = __webpack_public_path__ + "typing.png?4cbf14fea810004ebbd0930bb0220bb1";